var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30mm",
    height: "60mm",
    viewBox: "0 0 30 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.049 785.56c-0.05-3e-3 -0.098-0.01-0.147-0.012-2.082-0.206-3.75-1.871-4.879-4.261-0.386-0.822-0.711-1.726-0.964-2.686 0.251 0.217 0.55 0.429 0.892 0.624 0.743 0.422 1.764 0.817 2.934 0.932 2.607 0.256 7.036-0.404 8.726-5.165 1.787-5.032-2.026-14.841-5.443-21.948 1.659-2.883 2.676-4.711 4.556-7.78 0 0 8.129 12.394 8.221 12.578 2.581 5.197 4.019 11.571 3.634 16.678-0.614 8.19-5.729 10.621-5.795 10.682-0.134-0.058-0.272-0.13-0.413-0.211-1.81-1.085-1.857-2.816-8.146 0.195-0.673 0.324-1.57 0.402-2.33 0.402-0.313 0-0.604-0.012-0.846-0.028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cr)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.88 751.09 17.634 42.903 34.629-14.233-17.634-42.903z",
    fill: "url(#at)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "cr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x2: 1,
    gradientTransform: "matrix(7.3706 17.933 17.933 -7.3706 63.741 748.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.57374
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x2: 1,
    gradientTransform: "matrix(7.3706 17.933 17.933 -7.3706 63.741 748.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858380",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a19f9c",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.049 785.56c-0.05-3e-3 -0.098-0.01-0.147-0.012-2.082-0.206-3.75-1.871-4.879-4.261-0.386-0.822-0.711-1.726-0.964-2.686 0.251 0.217 0.55 0.429 0.892 0.624 0.743 0.422 1.764 0.817 2.934 0.932 2.607 0.256 7.036-0.404 8.726-5.165 1.787-5.032-2.026-14.841-5.443-21.948 1.659-2.883 3.088-5.827 4.713-8.756 0 0 8.717 15.109 8.807 15.294 2.583 5.198 3.692 11.283 3.271 15.033-0.43 3.811-1.175 5.175-2.111 6.58-0.327 0.492-3.998 3.946-4.064 4.007-0.134-0.058-0.272-0.13-0.413-0.211-1.81-1.085-1.857-2.816-8.146 0.195-0.673 0.324-1.57 0.402-2.33 0.402-0.313 0-0.604-0.012-0.846-0.028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.332 793.64 16.722-44.177-34.947-13.227-16.722 44.177z",
    fill: "url(#aj)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x2: 1,
    gradientTransform: "matrix(9.9825 -26.374 -26.374 -9.9825 67.671 790.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.57374
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x2: 1,
    gradientTransform: "matrix(9.9825 -26.374 -26.374 -9.9825 67.671 790.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9b98",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797775",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.073 783.01h21.758v-60.886h-21.758z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72.002 783.01c-2.681-0.028-4.642-0.901-4.706-1.524 12.524-0.41 13.529-9.172 1.286-31.313-4.642-8.395-6.486-16.113-6.509-21.298v-0.195c0.014-3.269 0.767-5.496 2.001-6.197 0.423-0.24 0.876-0.353 1.324-0.36h0.077c1.937 0.027 3.73 2.061 2.473 4.66-1.564 3.232-0.243 9.899 3.758 17.182 4 7.286 17.983 27.314 9.373 35.451-2.863 2.706-6.163 3.567-8.816 3.594z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.36 768.95-34.915-60.26-49.242 28.53 34.915 60.261z",
    fill: "url(#ah)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x2: 1,
    gradientTransform: "matrix(-29.153 -50.315 -50.315 29.153 77.869 770.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 0.15984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.84252
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x2: 1,
    gradientTransform: "matrix(-29.153 -50.315 -50.315 29.153 77.869 770.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797775",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2efea",
    offset: 0.84252
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2efea",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.906 782.26h16.23v-58.665h-16.23z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.906 723.59h16.23v58.664h-16.23z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.788 743.77h11.573v-25.177h-11.573z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.788 727.02c0-4.306 1.997-6.824 3.589-7.846 0.509-0.327 1.368-0.556 2.279-0.575h0.241c0.372 8e-3 0.748 0.051 1.109 0.139 2.454 0.598 4.312 3.06 4.355 7.641v0.33c-0.017 1.83-0.316 3.986-0.969 6.481-0.218 0.835-1.96 4.613-2.306 5.282-0.711 1.37-2.347 4.594-2.68 5.304-2.845-6.431-5.561-14.478-5.618-16.756"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.788 743.77h12.968v-25.36h-12.968z",
    fill: "url(#af)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x2: 1,
    gradientTransform: "matrix(0 58.214 58.214 0 64.575 721.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.018655
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x2: 1,
    gradientTransform: "matrix(0 58.214 58.214 0 64.575 721.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9b98",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2efea",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.059 786.1h23.748v-41.538h-23.748z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.023 781.29c-0.386-0.822-0.709-1.726-0.964-2.686 0.249 0.217 0.551 0.429 0.893 0.624 0.742 0.422 1.763 0.817 2.931 0.932 2.609 0.256 7.036-0.404 8.729-5.165 1.786-5.032-2.027-14.841-5.444-21.948 1.659-2.883 3.195-5.556 4.816-8.485 0 0 8.614 14.838 8.704 15.023 2.583 5.197 4.999 14.938 0.981 21.47-1.428 2.321-3.477 4.062-3.545 4.123-0.268-0.04-0.612-0.103-0.753-0.184-1.81-1.085-1.181-1.966-7.59 0.78-0.524 0.225-1.076 0.325-1.636 0.325-2.96 0-6.173-2.801-7.122-4.809"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.995 736.4-16.511 45.906 36.267 13.044 16.511-45.906z",
    fill: "url(#ad)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x2: 1,
    gradientTransform: "matrix(-15.183 42.213 42.213 15.183 84.516 744.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.018655
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x2: 1,
    gradientTransform: "matrix(-15.183 42.213 42.213 15.183 84.516 744.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9b98",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2efea",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.446 785.64h26.552v-67.035h-26.552z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.157 785.64c-2.085-0.015-4.42-1.718-5.289-2.693-1.01-1.135-2.554-3.386-2.809-4.346 0.834 0.721 2.244 1.401 3.824 1.556 2.609 0.256 7.036-0.404 8.729-5.165 1.786-5.032-2.027-14.841-5.444-21.948-0.08-0.167-0.162-0.335-0.243-0.5-0.343-0.609-4.377-8.367-4.519-8.773-2.492-7.188-4.903-14.553-4.96-16.83 0-3.899 1.382-8.275 5.258-8.336h0.164c0.359 5e-3 0.737 0.047 1.138 0.128 3.688 0.753 4.605 6.778 4.051 9.882 0 0-1.19 5.044-1.246 5.149 0 0 7.322 14.682 7.85 15.612 0.644 1.139 5.937 10.021 6.027 10.206 2.583 5.197 3.518 11.269 3.27 15.033-0.087 1.325-1.422 5.347-2.289 6.437-1.699 2.131-4.157 4.02-4.298 3.939-1.81-1.085-1.525-1.98-8.056 0.456-0.349 0.13-0.716 0.19-1.092 0.193z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.511 709.22-24.9 69.231 45.529 16.375 24.9-69.23z",
    fill: "url(#ab)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x2: 1,
    gradientTransform: "matrix(-23.072 64.149 64.149 23.072 83.548 719.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.018655
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x2: 1,
    gradientTransform: "matrix(-23.072 64.149 64.149 23.072 83.548 719.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44433e",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2efea",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.815 780.86c-0.339-0.035-1.523-0.266-2.243-0.505l-0.389-0.596-0.232-0.535c0.743 0.422 1.764 0.817 2.934 0.932 2.607 0.256 7.036-0.404 8.726-5.165 1.787-5.032-2.026-14.841-5.443-21.948-0.074-0.155-0.15-0.308-0.224-0.462 0.55-0.462 0.983-0.813 0.983-0.813 0.103 0.17 0.166 0.31 0.258 0.485 3.518 7.332 6.962 17.716 5.094 22.973-0.727 2.043-1.983 3.573-3.734 4.545-0.11 0.06-0.775 0.381-1.006 0.469-0.112 0.046-0.224 0.088-0.337 0.128-0.219 0.076-0.9 0.262-1.012 0.287-0.426 0.098-0.868 0.168-1.316 0.208-0.334 0.032-0.675 0.046-1.012 0.046-0.353 0-0.707-0.015-1.047-0.049"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bo)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.147 751.77h-14.195v29.141h14.195z",
    fill: "url(#z)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x2: 1,
    gradientTransform: "matrix(0 -28.636 -28.636 0 69.378 781.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x2: 1,
    gradientTransform: "matrix(0 -28.636 -28.636 0 69.378 781.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2efea",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2efea",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x2: 1,
    gradientTransform: "matrix(9.3658 6.0671 6.0671 -9.3658 60.415 782.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faf6f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.079 789.48c-0.142-0.01-6.595-0.377-7.442-0.624-1.326-0.516-1.657-1.391-2.205-2.106-0.322-0.421-0.546-0.55-0.841-0.618 0.202 0.043 0.442 0.099 0.713 0.168 0.742 0.185 1.371 0.461 2.106 0.786 0.674 0.297 1.439 0.633 2.421 1.034 0.543 0.222 1.695 0.643 2.301 0.807 0.617 0.165 2.153 0.432 2.301 0.453 0.204 0.029 0.615 0.081 0.814 0.109-0.057-2e-3 -0.113-4e-3 -0.168-9e-3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bk)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.591 789.5h10.655v-3.357h-10.655z",
    fill: "url(#w)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x2: 1,
    gradientTransform: "matrix(10.656 0 0 -10.656 58.591 787.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 0.090669
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x2: 1,
    gradientTransform: "matrix(10.656 0 0 -10.656 58.591 787.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0aeab",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faf6f2",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m79.322 784.96c0.026 0.016 0.055 0.033 0.082 0.05 1.033 0.68 3.049 1.039 4.847-1.672-2.641 4.472-5.102 4.061-7.655 3.648-1.667-0.27-3.373-0.539-5.19 0.55 2.559-1.649 5.469-4.094 7.916-2.576"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.33 777.95-11.798 6.401 4.795 8.839 11.798-6.401z",
    fill: "url(#u)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x2: 1,
    gradientTransform: "matrix(-14.584 7.9124 7.9124 14.584 85.944 781.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 0.047785
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.60223,
    offset: 0.52703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.60223,
    offset: 0.53763
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x2: 1,
    gradientTransform: "matrix(-14.584 7.9124 7.9124 14.584 85.944 781.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 0.52703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4b2af",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.136 790.4c-2.105-0.032-5.43-0.934-7.742-1.161-0.736-0.071-1.304-0.207-1.757-0.383 1.726 0.346 1.9 4e-3 6.828 0.562 0.023 4e-3 0.656 0.065 0.814 0.075 1.126 0.072 2.232-4e-3 3.147-0.493 1.149-0.617 2.234-0.875 3.274-0.986 0.781-0.085 1.536-0.085 2.276-0.083 0.487 0 0.966 0 1.441-0.022-1.959 0.45-5.325 1.725-6.967 2.329-0.292 0.106-0.661 0.155-1.092 0.162z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.637 790.41h17.78v-2.492h-17.78z",
    fill: "url(#s)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 1,
    gradientTransform: "matrix(17.78 0 0 -17.78 61.637 789.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.090669
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x2: 1,
    gradientTransform: "matrix(17.78 0 0 -17.78 61.637 789.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC9C6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faf6f2",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.257 783.3c-3.328-4.549-4.151-11.925-2.821-15.84 1.699-5.005 2.459-7.48 6.656-14.176 0.386-0.615-2.175 9.621-2.735 12.111-0.512 2.278-2.066 11.586 1.22 18.923 0.305 0.681 0.653 1.431 1.045 2.071-1.319-0.692-2.439-1.825-3.365-3.089"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.417 786.28-1.967-34.09-10.282 0.593 1.966 34.09z",
    fill: "url(#q)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(-1.9035 -32.993 -32.993 1.9035 57.846 786.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8,
    offset: 0.090669
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(-1.9035 -32.993 -32.993 1.9035 57.846 786.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.069 758.46c-0.061 0.293-0.099 0.457-0.099 0.457s0.033-0.162 0.099-0.457m-0.224-12.842c0.165-0.284 0.3-0.507 0.442-0.761 0.066-0.118 0.139-0.241 0.206-0.358 5.634-9.849 14.466-17.034 9.503-24.81-0.443-0.695-0.896-1.408-1.672-2.101 0.897 0.739 1.599 0.651 2.226 0.561 0.66-0.094 1.24-0.189 1.884 0.686 0.182 0.247 0.425 0.646 0.633 1.162 0.112 0.271 0.212 0.57 0.313 0.947 0 0 2.708-3.655 5.354-1 0.891 2.966 1.246 7.434-2.709 12.289-4.5 5.524-7.305 6.082-10.94 12.308-2.875 4.922-4.598 12.058-5.016 13.919 0.422-2.013 1.944-10.105-0.224-12.842"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ct)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.846 758.91h20.135v-41.628h-20.135z",
    fill: "url(#az)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "ct"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x2: 1,
    gradientTransform: "matrix(19.466 0 0 -19.466 62.846 738.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.090669
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x2: 1,
    gradientTransform: "matrix(19.466 0 0 -19.466 62.846 738.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dad7d3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faf6f2",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.581 781.04c-0.809-3.564-1.317-8.785-0.506-14.116 0.353-2.331 2.079-7.42 2.47-9.873-0.993 7.831-4.718 22.816 7.216 28.499-2.842-0.705-8.428-4.894-9.18-4.51"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.861 756.42-1.537 29.049 13.404 0.709 1.537-29.048z",
    fill: "url(#ax)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "cq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x2: 1,
    gradientTransform: "matrix(-.65218 12.326 12.326 .65218 62.369 766.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.090669
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x2: 1,
    gradientTransform: "matrix(-.65218 12.326 12.326 .65218 62.369 766.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBB8B5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faf6f2",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.136 790.4c-2.105-0.032-5.43-0.934-7.742-1.161-0.736-0.071-1.304-0.207-1.757-0.383-1.326-0.516-1.657-1.391-2.205-2.106-0.322-0.421-0.546-0.55-0.841-0.618-7e-3 -1e-3 -0.014-1e-3 -0.019-4e-3 -2.245-0.805-7.548-7.349-6.403-16.376 0.082-0.886 0.269-1.749 0.508-2.594 2.191-8.665 9.532-20.286 11.334-23.584-1.328-3.056-4.162-9.331-5.066-15.24-0.038-0.201-0.256-1.559-0.27-2.696-0.122-3.008 0.442-5.756 2.186-7.73 0.01-0.013 0.341-0.369 0.356-0.384 0.889-0.877 1.941-1.435 2.997-1.771h1e-3c1.496-0.642 2.636-0.283 3.733-0.096 0.493-0.298 1.007-0.528 1.53-0.707 3.148-1.088 6.669-0.215 8.32 0.707 2.213 0.719 3.222 2.02 3.854 4.032 0.637 1.896 1.612 5.768-0.594 11.496-0.994 2.475-2.986 6.347-6.06 11.974l-0.019 0.034c2.462 4.661 9.058 16.192 10.233 19.564 0.063 0.178 0.119 0.35 0.174 0.522 1.993 5.102 3.296 11.853-0.117 18.132-0.17 0.329-0.8 1.508-1.018 1.917-0.04 0.074-0.067 0.123-0.074 0.134-2.754 5.058-2.847 4.099-4.568 4.403-0.062 9e-3 -0.128 0.028-0.192 0.044-1.959 0.45-5.325 1.725-6.967 2.329-0.292 0.106-0.661 0.155-1.092 0.162zm2.15-44.426c-0.102 0.174-0.2 0.338-0.299 0.506-3.792 6.816-7.875 12.754-10.094 18.341-0.491 1.51-0.875 2.997-1.114 4.42-0.837 4.076-0.488 6.472 1.07 9.768 1.497 3.175 6.024 7.136 8.557 5.924 2.785-1.334 4.317-1.649 5.328-1.526 0.971 0.12 1.453 0.649 2.098 1.177 0.134 0.117 0.462 0.344 0.49 0.366 1.513-1.165 2.556-2.525 3.456-3.885 7.632-11.529-4.968-29.179-9.054-35.804-0.275 0.46-0.436 0.712-0.438 0.713m-9.382-26.539c-0.571 0.075-1.142 0.3-1.691 0.675-0.764 0.529-1.334 1.31-1.628 2.191-0.887 2.666-0.701 7.963 4.054 19.958 0.497-1.076 0.964-2.091 1.166-2.507 2.752-5.569 3.413-10.676 3.417-13.728-0.297-3.837-2.148-6.166-4.235-6.557-0.229-0.036-0.453-0.053-0.672-0.053-0.139 0-0.276 8e-3 -0.411 0.021"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#co)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.411 713.87h-39.387v76.539h39.387z",
    fill: "url(#av)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "co"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x2: 1,
    gradientTransform: "matrix(0 -66.269 -66.269 0 69.694 783.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.022539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.51242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.98275
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x2: 1,
    gradientTransform: "matrix(0 -66.269 -66.269 0 69.694 783.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dad7d3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 0.51242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eeebe7",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.242 790.41c-2.098-2e-3 -5.498-0.931-7.848-1.162-0.736-0.071-1.304-0.207-1.757-0.383-1.326-0.516-1.657-1.391-2.205-2.106-0.322-0.421-0.546-0.55-0.841-0.618-7e-3 -1e-3 -0.014-1e-3 -0.019-4e-3 -2.245-0.805-7.548-7.349-6.403-16.376 0.082-0.886 0.269-1.749 0.508-2.594 2.191-8.665 9.532-20.286 11.334-23.584-1.328-3.056-4.162-9.331-5.066-15.24-0.038-0.201-0.256-1.559-0.27-2.698-0.122-3.006 0.442-5.754 2.186-7.728 0.01-0.013 0.341-0.369 0.356-0.384 0.889-0.877 1.941-1.435 2.997-1.771h1e-3c1.496-0.642 2.636-0.283 3.733-0.096 0.493-0.298 1.007-0.528 1.53-0.707 1.069-0.369 2.18-0.512 3.247-0.506 2.075 0.015 3.984 0.605 5.073 1.213 2.213 0.719 3.222 2.02 3.854 4.032 0.637 1.896 1.612 5.768-0.594 11.496-0.994 2.475-2.986 6.347-6.06 11.974l-0.019 0.034c2.462 4.661 9.058 16.192 10.233 19.564 0.063 0.178 0.119 0.35 0.174 0.522 1.993 5.102 3.296 11.853-0.117 18.132-0.17 0.327-0.8 1.508-1.018 1.917-0.04 0.074-0.067 0.123-0.074 0.134-2.754 5.058-2.847 4.099-4.568 4.403-0.062 9e-3 -0.128 0.028-0.192 0.044-1.959 0.45-5.325 1.725-6.967 2.329-0.312 0.114-0.717 0.163-1.187 0.163zm2.044-44.427c-0.102 0.174-0.2 0.338-0.299 0.506-3.792 6.816-7.875 12.754-10.094 18.341-0.491 1.51-0.875 2.997-1.114 4.42-0.837 4.076-0.488 6.472 1.07 9.768 1.497 3.175 6.024 7.136 8.557 5.924 2.785-1.334 4.317-1.649 5.328-1.526 0.971 0.12 1.453 0.649 2.098 1.177 0.134 0.117 0.462 0.344 0.49 0.366 1.513-1.165 2.556-2.525 3.456-3.885 7.632-11.529-4.968-29.179-9.054-35.804-0.275 0.46-0.436 0.712-0.438 0.713m-9.382-26.539c-0.571 0.075-1.142 0.3-1.691 0.675-0.764 0.529-1.334 1.31-1.628 2.191-0.887 2.666-0.701 7.963 4.054 19.958 0.497-1.076 0.964-2.091 1.166-2.507 2.752-5.569 3.413-10.676 3.417-13.728-0.297-3.837-2.148-6.166-4.235-6.557-0.229-0.036-0.453-0.053-0.672-0.053-0.139 0-0.276 8e-3 -0.411 0.021"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.411 714.44h-39.387v75.964h39.387z",
    fill: "url(#as)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-32768 32767h65535v-65535h-65535z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x2: 1,
    gradientTransform: "matrix(0 -66.269 -66.269 0 69.694 787.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.022539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.51242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.98275
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x2: 1,
    gradientTransform: "matrix(0 -66.269 -66.269 0 69.694 787.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dad7d3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 0.51242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eeebe7",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.944 763.32h22.436v-40.878h-22.436z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x2: 1,
    gradientTransform: "matrix(-9.2897 38.204 38.204 9.2897 73.017 721.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faf6f2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 0.51242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbf7",
    offset: 0.67731
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebe7e3",
    offset: 0.90099
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC9C6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x2: 1,
    gradientTransform: "matrix(-6.2679 -10.818 -10.818 6.2679 60.427 781.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af1c3b",
    offset: 0.53465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x2: 1,
    gradientTransform: "matrix(-6.2683 -10.819 -10.819 6.2683 59.238 782.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af1c3b",
    offset: 0.53465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x2: 1,
    gradientTransform: "matrix(-6.2677 -10.818 -10.818 6.2677 62.318 780.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af1c3b",
    offset: 0.53465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x2: 1,
    gradientTransform: "matrix(23.651 56.171 56.171 -23.651 62.473 693.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af1c3b",
    offset: 0.53465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51.024 713.87h168.66v76.999h-168.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.24 744.07h12.812v-18.054h-12.812z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x2: 1,
    gradientTransform: "matrix(27.571 -61.706 -61.706 -27.571 62.141 762.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#af1c3b",
    offset: 0.53465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791426",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.72827 0 0 -.72827 -35.756 577.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.168 753.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.494 4.186-4.797 8.061-6.275 11.782-0.49 1.509-0.875 2.995-1.113 4.419-0.838 4.076-0.488 6.47 1.069 9.769 0.033 0.069 0.068 0.14 0.104 0.211 0.741 0.423 1.762 0.817 2.932 0.932 2.607 0.257 7.034-0.404 8.727-5.166 1.786-5.031-2.027-14.84-5.444-21.947m16.101 28.371c-0.17 0.327-0.801 1.51-1.018 1.915-0.041 0.075-0.068 0.124-0.074 0.135-2.754 5.057-2.847 4.099-4.566 4.403-0.064 0.011-0.13 0.028-0.194 0.044-1.958 0.451-5.323 1.726-6.967 2.33-1.699 0.622-6.17-0.716-9.056-1-0.734-0.071-1.303-0.206-1.757-0.383-1.327-0.515-1.657-1.39-2.205-2.107-0.32-0.42-0.544-0.547-0.841-0.617-6e-3 -1e-3 -0.014-1e-3 -0.018-3e-3 -2.245-0.805-7.549-7.348-6.403-16.377 0.082-0.886 0.268-1.749 0.507-2.594 2.193-8.665 9.532-20.286 11.334-23.584-1.328-3.056-4.162-9.331-5.066-15.241-0.037-0.2-0.256-1.558-0.27-2.698-0.12-3.004 0.443-5.753 2.185-7.727 0.011-0.012 0.342-0.367 0.357-0.383 0.891-0.878 1.941-1.436 2.998-1.771 1.496-0.644 2.634-0.284 3.735-0.097 0.491-0.298 1.005-0.528 1.528-0.707 3.148-1.088 6.67-0.215 8.32 0.707 2.213 0.719 3.222 2.018 3.854 4.032 0.637 1.897 1.612 5.768-0.595 11.497-0.991 2.474-2.985 6.346-6.057 11.974l-0.02 0.033c2.463 4.661 9.058 16.194 10.232 19.564 0.064 0.178 0.119 0.35 0.174 0.522 1.994 5.102 3.296 11.851-0.117 18.133",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.296 737.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.711 1.371-2.267 4.358-2.599 5.068-3.616-7.046-4.508-14.871-4.565-17.145 0.038-1.748 0-4.399 2.472-5.528 3.28 4.467-2.472 11.141 4.692 17.605",
    fill: "#aca9a6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.597 760.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.846 4.201 2.955 7.783 0.277 13.622-2.206 4.807-6.003 6.527-9.991 5.621h1e-3c2.609 0.257 7.037-0.402 8.728-5.166 1.786-5.031-2.027-14.84-5.444-21.947-0.078-0.167-0.163-0.334-0.243-0.5 1.661-2.883 3.02-5.364 4.642-8.294 0 0 2.186 3.528 3.094 5.126-1.862 4.314-1.592 8.921-1.064 11.538",
    fill: "#aca9a6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.958 774.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2e-3 0.145-2e-3 0.293-5e-3 0.432v0.024c-1e-3 0.063-4e-3 0.119-4e-3 0.181-0.023 0.629-0.067 1.173-0.127 1.623-0.064 0.443-0.141 0.773-0.212 1.009-0.316 0.947-1.074 2.079-1.942 3.168-1.698 2.131-3.818 4.089-3.884 4.151-0.134-0.059-0.271-0.13-0.413-0.212-1.811-1.084-1.769-2.556-8.058 0.456-0.95 0.455-2.435 0.167-3.266 0.112 6.359-4.723 13.338-4.521 17.911-10.944",
    fill: "#bcbab7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.079 756.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.243 0.367 0.463 0.708 0.66 1.018 0.235 0.385 0.458 0.779 0.669 1.178 0.096 0.181 0.189 0.364 0.28 0.548 2.582 5.197 3.306 11.261 3.269 15.033-3.236 9.402-12.671 5.209-15.693 11.071-0.05-3e-3 -2.313-0.135-2.361-0.14 0.148-0.189 0.301-0.375 0.462-0.561 1.198-1.368 4.004-4.144 7.022-4.852 3.02-0.709 5.552-1.149 8.1-4.944 2.548-3.798-0.162-9.149-2.548-14.404-0.952-2.096-1.047-4.202-1.186-6.281 0.388 0.536 0.472 1.16 0.932 1.778 0.134 0.182 0.265 0.368 0.394 0.556",
    fill: "#ccc9c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.488 775.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.549 3.797-5.08 4.237-8.1 4.945-3.019 0.707-5.824 3.485-7.022 4.853-0.161 0.184-0.314 0.372-0.462 0.559-2.082-0.203-3.752-1.871-4.879-4.259-0.387-0.821-0.711-1.726-0.966-2.684 0.834 0.722 2.245 1.4 3.826 1.554 3.986 0.907 7.785-0.813 9.99-5.622 2.679-5.837 0.569-9.421-0.278-13.62-0.528-2.617-0.797-7.224 1.064-11.538 0.647 1.139 1.346 2.714 3.093 5.127 0.139 2.081 0.233 4.187 1.185 6.281 2.387 5.256 5.096 10.608 2.549 14.404",
    fill: "#bbb8b5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cv)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.049 785.56c-0.05-3e-3 -0.098-0.01-0.147-0.012-2.082-0.206-3.75-1.871-4.879-4.261-0.386-0.822-0.711-1.726-0.964-2.686 0.251 0.217 0.55 0.429 0.892 0.624 0.743 0.422 1.764 0.817 2.934 0.932 2.607 0.256 7.036-0.404 8.726-5.165 1.787-5.032-2.026-14.841-5.443-21.948 1.659-2.883 2.676-4.711 4.556-7.78 0 0 8.129 12.394 8.221 12.578 2.581 5.197 4.019 11.571 3.634 16.678-0.614 8.19-5.729 10.621-5.795 10.682-0.134-0.058-0.272-0.13-0.413-0.211-1.81-1.085-1.857-2.816-8.146 0.195-0.673 0.324-1.57 0.402-2.33 0.402-0.313 0-0.604-0.012-0.846-0.028",
    fill: "url(#ak)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.42 743.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.815-3.926-7.136-24.908-0.854-24.173 9.862 1.381 2.161 21.497 0.854 24.173",
    fill: "#9a9794"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.049 785.56c-0.05-3e-3 -0.098-0.01-0.147-0.012-2.082-0.206-3.75-1.871-4.879-4.261-0.386-0.822-0.711-1.726-0.964-2.686 0.251 0.217 0.55 0.429 0.892 0.624 0.743 0.422 1.764 0.817 2.934 0.932 2.607 0.256 7.036-0.404 8.726-5.165 1.787-5.032-2.026-14.841-5.443-21.948 1.659-2.883 3.088-5.827 4.713-8.756 0 0 8.717 15.109 8.807 15.294 2.583 5.198 3.692 11.283 3.271 15.033-0.43 3.811-1.175 5.175-2.111 6.58-0.327 0.492-3.998 3.946-4.064 4.007-0.134-0.058-0.272-0.13-0.413-0.211-1.81-1.085-1.857-2.816-8.146 0.195-0.673 0.324-1.57 0.402-2.33 0.402-0.313 0-0.604-0.012-0.846-0.028",
    fill: "url(#ai)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72.002 783.01c-2.681-0.028-4.642-0.901-4.706-1.524 12.524-0.41 13.529-9.172 1.286-31.313-4.642-8.395-6.486-16.113-6.509-21.298v-0.195c0.014-3.269 0.767-5.496 2.001-6.197 0.423-0.24 0.876-0.353 1.324-0.36h0.077c1.937 0.027 3.73 2.061 2.473 4.66-1.564 3.232-0.243 9.899 3.758 17.182 4 7.286 17.983 27.314 9.373 35.451-2.863 2.706-6.163 3.567-8.816 3.594z",
    fill: "url(#ag)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bz)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.184 781.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.705 0.229 1.441 0.356 2.177 0.433 0.739 0.079 1.485 0.092 2.227 0.043 1.485-0.099 2.974-0.462 4.305-1.184 1.333-0.714 2.463-1.801 3.278-3.086 0.402-0.646 0.732-1.334 1.006-2.043 0.252-0.714 0.468-1.44 0.618-2.184 0.611-2.984 0.331-6.074-0.289-9.015-0.63-2.952-1.601-5.812-2.734-8.576-1.124-2.771-2.434-5.446-3.765-8.091l-2.025-3.941-1.986-3.936c-1.278-2.632-2.513-5.282-3.367-8.04-0.216-0.689-0.394-1.385-0.534-2.09-0.15-0.7-0.257-1.411-0.295-2.123-0.087-1.425 0.071-2.878 0.643-4.234l-0.172-0.091c-0.832 1.259-1.242 2.796-1.336 4.322-0.103 1.53 0.082 3.062 0.389 4.547 0.295 1.491 0.75 2.935 1.241 4.355 0.491 1.422 1.067 2.806 1.661 4.176 2.4 5.466 5.225 10.657 7.73 15.945 0.618 1.326 1.232 2.651 1.775 4.002 0.553 1.348 1.06 2.713 1.469 4.104 0.824 2.772 1.291 5.694 0.868 8.556-0.093 0.714-0.287 1.414-0.495 2.103-0.232 0.681-0.518 1.343-0.871 1.969-0.721 1.242-1.744 2.31-2.994 3.047-1.245 0.742-2.679 1.158-4.136 1.313-0.73 0.077-1.467 0.094-2.202 0.047-0.734-0.049-1.469-0.145-2.181-0.345z",
    fill: "#797775"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.788 727.02c0-4.306 1.997-6.824 3.589-7.846 0.509-0.327 1.368-0.556 2.279-0.575h0.241c0.372 8e-3 0.748 0.051 1.109 0.139 2.454 0.598 4.312 3.06 4.355 7.641v0.33c-0.017 1.83-0.316 3.986-0.969 6.481-0.218 0.835-1.96 4.613-2.306 5.282-0.711 1.37-2.347 4.594-2.68 5.304-2.845-6.431-5.561-14.478-5.618-16.756",
    fill: "url(#ae)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.023 781.29c-0.386-0.822-0.709-1.726-0.964-2.686 0.249 0.217 0.551 0.429 0.893 0.624 0.742 0.422 1.763 0.817 2.931 0.932 2.609 0.256 7.036-0.404 8.729-5.165 1.786-5.032-2.027-14.841-5.444-21.948 1.659-2.883 3.195-5.556 4.816-8.485 0 0 8.614 14.838 8.704 15.023 2.583 5.197 4.999 14.938 0.981 21.47-1.428 2.321-3.477 4.062-3.545 4.123-0.268-0.04-0.612-0.103-0.753-0.184-1.81-1.085-1.181-1.966-7.59 0.78-0.524 0.225-1.076 0.325-1.636 0.325-2.96 0-6.173-2.801-7.122-4.809",
    fill: "url(#ac)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.157 785.64c-2.085-0.015-4.42-1.718-5.289-2.693-1.01-1.135-2.554-3.386-2.809-4.346 0.834 0.721 2.244 1.401 3.824 1.556 2.609 0.256 7.036-0.404 8.729-5.165 1.786-5.032-2.027-14.841-5.444-21.948-0.08-0.167-0.162-0.335-0.243-0.5-0.343-0.609-4.377-8.367-4.519-8.773-2.492-7.188-4.903-14.553-4.96-16.83 0-3.899 1.382-8.275 5.258-8.336h0.164c0.359 5e-3 0.737 0.047 1.138 0.128 3.688 0.753 4.605 6.778 4.051 9.882 0 0-1.19 5.044-1.246 5.149 0 0 7.322 14.682 7.85 15.612 0.644 1.139 5.937 10.021 6.027 10.206 2.583 5.197 3.518 11.269 3.27 15.033-0.087 1.325-1.422 5.347-2.289 6.437-1.699 2.131-4.157 4.02-4.298 3.939-1.81-1.085-1.525-1.98-8.056 0.456-0.349 0.13-0.716 0.19-1.092 0.193z",
    fill: "url(#aa)"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.815 780.86c-0.339-0.035-1.523-0.266-2.243-0.505l-0.389-0.596-0.232-0.535c0.743 0.422 1.764 0.817 2.934 0.932 2.607 0.256 7.036-0.404 8.726-5.165 1.787-5.032-2.026-14.841-5.443-21.948-0.074-0.155-0.15-0.308-0.224-0.462 0.55-0.462 0.983-0.813 0.983-0.813 0.103 0.17 0.166 0.31 0.258 0.485 3.518 7.332 6.962 17.716 5.094 22.973-0.727 2.043-1.983 3.573-3.734 4.545-0.11 0.06-0.775 0.381-1.006 0.469-0.112 0.046-0.224 0.088-0.337 0.128-0.219 0.076-0.9 0.262-1.012 0.287-0.426 0.098-0.868 0.168-1.316 0.208-0.334 0.032-0.675 0.046-1.012 0.046-0.353 0-0.707-0.015-1.047-0.049",
    fill: "url(#y)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bn)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.725 745.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.274 0.459-0.437 0.711-0.438 0.712-0.103 0.174-0.2 0.339-0.3 0.506-3.792 6.818-7.875 12.755-10.095 18.343-0.489 1.509-0.874 2.996-1.113 4.418-0.837 4.078-0.487 6.472 1.07 9.77 1.497 3.174 6.024 7.135 8.557 5.922 5.462-2.615 6.189-1.353 7.506-0.279 0.041 0.031 0.144 0.107 0.186 0.146 0.029 0.022 0.196 0.13 0.224 0.15 14.32-11.007-1.031-32.281-5.597-39.688m-8.737-25.794c-0.377-0.059-0.738-0.069-1.083-0.033-0.571 0.076-1.143 0.3-1.69 0.677-0.766 0.528-1.335 1.308-1.628 2.191-0.889 2.663-0.703 7.961 4.053 19.958 0.495-1.078 0.961-2.092 1.166-2.508 2.752-5.569 3.413-10.677 3.416-13.727-0.297-3.839-2.147-6.167-4.234-6.558m20.281 61.945c-0.17 0.326-0.8 1.508-1.018 1.915-0.041 0.076-0.068 0.125-0.074 0.136-2.754 5.056-2.847 4.096-4.568 4.4-0.061 0.011-0.128 0.03-0.192 0.045-1.958 0.45-5.325 1.727-6.969 2.329-1.697 0.623-6.168-0.714-9.054-0.997-0.736-0.073-1.303-0.207-1.757-0.383-1.327-0.516-1.657-1.391-2.205-2.108-0.32-0.419-0.546-0.548-0.842-0.616-5e-3 -2e-3 -0.013-2e-3 -0.017-5e-3 -2.245-0.804-7.549-7.348-6.403-16.375 0.08-0.886 0.268-1.75 0.506-2.596 2.194-8.664 9.533-20.287 11.335-23.583-1.328-3.057-4.162-9.331-5.066-15.24-0.037-0.2-0.256-1.561-0.27-2.697v-2e-3c-0.121-3.004 0.441-5.755 2.185-7.728 0.011-0.011 0.342-0.367 0.358-0.383 0.889-0.876 1.94-1.436 2.998-1.772 1.495-0.643 2.633-0.282 3.732-0.094 0.493-0.3 1.007-0.528 1.531-0.708 3.147-1.089 6.669-0.214 8.319 0.708 2.213 0.718 3.22 2.017 3.854 4.03 0.637 1.896 1.612 5.769-0.594 11.497-0.993 2.475-2.986 6.348-6.058 11.975l-0.02 0.033c2.462 4.661 9.057 16.193 10.233 19.564 0.063 0.177 0.118 0.349 0.173 0.52 1.994 5.103 3.296 11.854-0.117 18.135",
    fill: "#efece8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.336 754.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.207-0.334-0.735-1.124-1.392-2.098-1.638-2.771-3.195-5.121-4.218-6.781 0.333-0.537 1.075-1.746 1.392-2.322-0.041 0.073-0.079 0.144-0.118 0.218l-0.021 0.033c0.158 0.298 0.334 0.626 0.524 0.979 7e-3 1.874 3.195 8.515 3.833 9.971",
    fill: "#dad7d3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.427 789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.209 0.648-2.752 0.596-4.223 0.339-0.449-0.079-1.522-0.285-1.522-0.285s2.169-0.533 3.901-1.145c1.116-0.427 2.988-1.15 5.244 0.04l0.042 0.097c-1.04 0.111-2.293 0.338-3.442 0.954",
    fill: "#bbb8b5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m65.369 788.49c-0.496-0.197-0.93-0.37-1.238-0.54-4.07-2.257-5.226-4.491-5.419-4.672-0.116-0.786-0.294-1.389-0.382-2.345 0.753-0.388 4.404 0.323 6.831 2.234 0.301 0.252 0.618 0.493 0.948 0.722 0.128 0.099 0.245 0.159 0.343 0.233 0.016 6e-3 0.03 0.037 0.045 0.043 1.388 1.24 3.021 4.28 4.548 3.529 0.122-0.06 0.243-0.115 0.361-0.165-0.18 0.104-0.361 0.207-0.544 0.306-1.094 0.587-2.252 1.015-3.51 1.015-0.633 0-1.293-0.109-1.983-0.36",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.351 785.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.181-0.451-0.331-0.886-0.433-1.444-0.071-0.383-0.139-0.801-0.205-1.248 2.566 3.184 5.152 4.546 5.42 4.673 0.3 0.148 1.124 0.713 1.49 0.834-2.784-0.755-4.338-1.89-6.001-2.393-0.074-0.067-0.228-0.316-0.271-0.422",
    fill: "#f6f2ee"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.984 784.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4.254 2.385-6.447-0.648-6.448-0.649-0.013-4e-3 -0.026-0.046-0.038-0.051-1.512-1.352-3.025-3.236-3.651-5.151 1.499 3.175 6.026 7.136 8.559 5.922 5.99-2.867 6.291-1.08 7.916 0.017-1.187-0.717-2.169-2.424-6.338-0.088",
    fill: "#ebe7e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.904 784.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.792-1.168-4.677 1.121-7.497 2.787-0.119 0.052-0.239 0.105-0.361 0.167-1.959 0.976-5.256-4.199-5.248-4.195 0.63 0.464 2.933 3.749 7.187 1.364 4.168-2.336 4.789-1.009 5.922-0.211 0.057 0.039 0.416 0.299 0.416 0.299s-0.362-0.167-0.416-0.209l-3e-3 -2e-3",
    fill: "#fffbf7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.161 783.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.429-1.847-6.078-2.621-6.83-2.235-0.331-3.649-1.125-8.367-0.317-13.698 0.353-2.328 0.825-4.806 1.217-7.258-0.996 7.832-1.207 17.234 5.93 23.191",
    fill: "#efece8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.637 788.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.327-0.516-1.657-1.39-2.205-2.107-0.322-0.42-0.546-0.549-0.842-0.617 0.203 0.043 0.443 0.1 0.716 0.167 0.741 0.186 1.369 0.461 2.104 0.785 0.675 0.298 1.439 0.636 2.42 1.036 0.545 0.222 1.697 0.641 2.304 0.805 0.615 0.167 2.213 0.439 2.3 0.456 0 0 0.614 0.079 0.813 0.109-0.057-4e-3 -6.762-0.387-7.61-0.634",
    fill: "#efece8"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.079 789.48c-0.142-0.01-6.595-0.377-7.442-0.624-1.326-0.516-1.657-1.391-2.205-2.106-0.322-0.421-0.546-0.55-0.841-0.618 0.202 0.043 0.442 0.099 0.713 0.168 0.742 0.185 1.371 0.461 2.106 0.786 0.674 0.297 1.439 0.633 2.421 1.034 0.543 0.222 1.695 0.643 2.301 0.807 0.617 0.165 2.153 0.432 2.301 0.453 0.204 0.029 0.615 0.081 0.814 0.109-0.057-2e-3 -0.113-4e-3 -0.168-9e-3",
    fill: "url(#v)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.741 717.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.066-0.139-0.118-0.26-0.186-0.38-0.233-0.457-0.486-0.881-0.757-1.261 2.226 0.724 3.222 1.997 3.854 4.032-2.358-2.476-2.911-2.391-2.911-2.391",
    fill: "#d2cfcb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.568 716.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.773 0.777-3.198-0.747-4.089-1.671 3.148-1.087 6.669-0.213 8.32 0.71 0.269 0.379 0.523 0.802 0.756 1.259-0.931-1.548-3.272-1.05-4.987-0.298",
    fill: "#dedbd7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.119 719.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.898 1.768 1.374 4.971 1.103 6.765-0.301-3.827-2.151-6.166-4.233-6.557-0.377-0.06-0.74-0.069-1.083-0.033-0.572 0.076-1.143 0.299-1.692 0.676-0.091 0.063-0.178 0.131-0.264 0.2-1.589 0.473-2.868 1.819-3.244 3.467-3e-3 0.017-0.01 0.031-0.013 0.047 0.016-0.268 0.041-0.535 0.073-0.798l6e-3 -0.057c0.098-0.796 0.263-1.56 0.509-2.279 1.751-3.171 6.79-5.463 8.838-1.431",
    fill: "#ebe7e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.988 719.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.377-0.06-0.738-0.069-1.083-0.033-0.57 0.076-1.143 0.299-1.69 0.676-0.419 0.29-0.78 0.654-1.07 1.072-1.437 1.488-2.229 4.142-2.356 5.944l-5e-3 0.066v-1e-3 1e-3 -3e-3c-0.054-0.478-0.103-1.039-0.109-1.554v-2e-3c-0.044-1.091 3e-3 -2.148 0.163-3.148 6e-3 -0.018 9e-3 -0.037 0.012-0.058 1.591-3.025 6.006-6.042 8.945-0.947-0.764-1.127-1.756-1.816-2.807-2.013",
    fill: "#f2efea"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.177 783.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.754 5.057-2.847 4.098-4.568 4.401-2.33-0.125-4.934-1.751-8.203-0.339 4.601-2.754 8.476 3.187 12.834-4.179 3e-3 -6e-3 0.054-0.102 0.058-0.108-0.019 0.033-0.033 0.063-0.049 0.089-0.039 0.076-0.066 0.125-0.072 0.136",
    fill: "#e7e4e0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m79.322 784.96c0.026 0.016 0.055 0.033 0.082 0.05 1.033 0.68 3.049 1.039 4.847-1.672-2.641 4.472-5.102 4.061-7.655 3.648-1.667-0.27-3.373-0.539-5.19 0.55 2.559-1.649 5.469-4.094 7.916-2.576",
    fill: "url(#t)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.216 715.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c1.157 0.723 2.144 1.734 2.929 2.907-2.187-2.01-6.922-1.358-8.313 3.863 0.279-1.765 0.911-3.35 2.028-4.615 0.011-0.013 0.342-0.368 0.358-0.383 0.889-0.878 1.94-1.436 2.998-1.772",
    fill: "#ccc9c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.449 790.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.698 0.623-6.168-0.716-9.055-0.998-0.735-0.072-1.304-0.208-1.756-0.383 1.707 0.371 1.825 2e-3 6.826 0.561 0.025 4e-3 0.656 0.065 0.817 0.074 1.124 0.073 2.232-3e-3 3.146-0.493 1.149-0.615 2.233-0.875 3.274-0.987 1.295-0.138 2.523-0.044 3.715-0.104-1.956 0.451-5.323 1.728-6.967 2.33",
    fill: "#f2efea"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.136 790.4c-2.105-0.032-5.43-0.934-7.742-1.161-0.736-0.071-1.304-0.207-1.757-0.383 1.726 0.346 1.9 4e-3 6.828 0.562 0.023 4e-3 0.656 0.065 0.814 0.075 1.126 0.072 2.232-4e-3 3.147-0.493 1.149-0.617 2.234-0.875 3.274-0.986 0.781-0.085 1.536-0.085 2.276-0.083 0.487 0 0.966 0 1.441-0.022-1.959 0.45-5.325 1.725-6.967 2.329-0.292 0.106-0.661 0.155-1.092 0.162z",
    fill: "url(#r)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.7 788.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-0.136-0.069c-1.864-1.006-3.586-0.539-4.701-0.112 0.182-0.098 0.365-0.2 0.543-0.308 3.269-1.412 5.873 0.216 8.203 0.341-0.061 0.011-0.128 0.028-0.192 0.044-1.192 0.06-2.42-0.035-3.717 0.104",
    fill: "#ebe7e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.336 730.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.117 9.341-6.723 15.423-10.78 20.406-3.444 4.226-5.317 8.784-6.179 12.908 0.085-0.946 0.163-1.938 0.227-2.948 0.785-5.729 2.921-12.534 9.205-20.234 5.71-6.995 6.919-7.949 7.527-10.132",
    fill: "#fffbf7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.357 783.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-2e-3 0.066-0.153 0.066-0.153 0.016-0.036 0.396-0.933 0.41-0.968 1.061-2.49-0.036-4.541-0.246-4.894 1.531-5.417-0.074-11.615-2.56-17.249-1.083-2.468-1.043-4.68-1.357-6.24 3e-3 8e-3 8e-3 0.016 0.011 0.022 2.065 3.819 3.953 7.451 4.532 9.109 0.063 0.178 0.118 0.35 0.173 0.522 1.993 5.102 3.296 11.852-0.116 18.133-0.149 0.284-0.643 1.212-0.913 1.718",
    fill: "#ebe7e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.322 784.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 1.508,-1.16 2.555,-2.528 3.453,-3.887 3.148,-1.732 2.604,0.407 0.801,0.224 0.574,0.199 0.363,0.158 0.147,0.068 0.14,0.066 0.121,0.095 0,0",
    fill: "#dedbd7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.879 782.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.014 0.035-1.072 1.57-1.674 2.183-0.662 0.717-1.622 1.144-2.462 1.122-0.774-0.02-1.078-0.227-1.318-0.345-0.038-0.017-0.082-0.052-0.102-0.066 2.58 0.741 3.072-1.754 3.453-3.885 0.829-1.255 1.424-2.579 1.811-3.955 0.147 0.276 1.244 2.495 0.292 4.946",
    fill: "#ccc9c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.479 714.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 1.121,0.916 2.044,1.915 3.225,1.876 2.375,1.912 -0.796,1.231 -1.531,0.708 -1.037,0.41 -0.523,0.18 0,0",
    fill: "#d2cfcb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.316 724.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.033 0.872-0.131 1.735-0.292 2.569-0.321 1.662-0.904 3.209-1.801 4.475-3.307 4.664-11.233 13.263-13.289 19.962 0.597-4.199-0.421-9.248 1.261-11.728 0.572-0.737 1.125-1.464 1.653-2.176 4.034-4.814 8.729-7.606 8.581-14.435-0.079-3.618-1.296-4.909-3.075-6.577 0.069-0.023 0.14-0.05 0.214-0.082 1.717-0.748 4.056-1.249 4.986 0.298 1.201 2.349 1.885 4.524 1.762 7.694",
    fill: "#efece8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.738 722.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c1.067 8.783-4.004 13.488-8.835 19.024-0.559 0.622-2.173 1.33-1.54-0.128 2.727-4.287 4.546-8.446 4.978-10.176 2.547-10.211-0.251-13.441-3.392-15.763 0.734 0.524 3.906 1.205 4.754 1.168 0.208-6e-3 0.424-0.045 0.651-0.123 1.447 1.358 2.456 2.072 3.026 4.234 0.081 0.3 0.153 0.634 0.226 1.003 0.047 0.238 0.099 0.49 0.132 0.761",
    fill: "#e7e4e0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.012 729.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.179 4.722-3.974 12.093-8.934 18.529-0.076-0.23-0.514-1.619-0.877-2.652 0.33-0.569 0.606-1.049 0.809-1.421 0.255-0.494 0.419-0.837 0.629-1.315 0.495-1.078 0.962-2.092 1.166-2.508 2.753-5.569 3.413-10.676 3.416-13.727 0.205-3.824-1.709-8.212-5.006-10.271 1.496-0.645 2.634-0.284 3.734-0.096 2.684 0.977 7.61 3.249 5.063 13.461",
    fill: "#f2efea"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.257 783.3c-3.328-4.549-4.151-11.925-2.821-15.84 1.699-5.005 2.459-7.48 6.656-14.176 0.386-0.615-2.175 9.621-2.735 12.111-0.512 2.278-2.066 11.586 1.22 18.923 0.305 0.681 0.653 1.431 1.045 2.071-1.319-0.692-2.439-1.825-3.365-3.089",
    fill: "url(#p)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.76 785.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.526-0.735-2.845-1.827-3.955-3.064-1.113-1.241-1.976-2.683-2.58-4.22-1.204-3.091-1.296-6.508-0.769-9.78 0.496-3.296 1.686-6.482 2.364-9.841 0.344-1.674 0.536-3.395 0.481-5.108-0.059-1.712-0.36-3.41-0.886-5.021 0.329 1.663 0.503 3.347 0.435 5.021-0.05 1.674-0.333 3.327-0.728 4.954-0.405 1.625-0.9 3.236-1.387 4.862-0.472 1.63-0.913 3.288-1.181 4.991-0.258 1.701-0.361 3.436-0.222 5.164 0.083 0.862 0.202 1.722 0.414 2.564 0.201 0.843 0.47 1.674 0.825 2.465 0.692 1.592 1.685 3.047 2.913 4.255 1.234 1.191 2.667 2.205 4.276 2.758",
    fill: "#ccc9c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.301 745.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.339 0.903 0.556 1.841 0.659 2.793 0.083 0.954 0.104 1.912 0.033 2.869-0.101 1.915-0.394 3.819-0.681 5.723-0.277 1.906-0.597 3.808-0.854 5.719-0.271 1.909-0.361 3.825-0.544 5.745l1.742-11.412c0.287-1.907 0.554-3.824 0.619-5.763 0.038-0.969-0.019-1.941-0.135-2.903-0.164-0.958-0.423-1.899-0.839-2.771",
    fill: "#ccc9c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.51 784.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.372-1.214-0.708-2.437-0.954-3.677-0.264-1.238-0.458-2.488-0.58-3.744-0.253-2.511-0.253-5.047 8e-3 -7.555 0.245-2.511 0.831-4.976 1.457-7.43 0.309-1.23 0.644-2.454 0.925-3.696 0.263-1.241 0.514-2.504 0.476-3.779-0.058 1.271-0.348 2.508-0.679 3.73-0.328 1.223-0.694 2.437-1.044 3.657-0.708 2.438-1.285 4.932-1.571 7.472-0.131 1.271-0.188 2.548-0.172 3.824 0.017 1.276 0.083 2.552 0.25 3.816 0.166 1.266 0.404 2.519 0.71 3.755 0.321 1.231 0.703 2.446 1.174 3.627",
    fill: "#ccc9c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.131 783.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.558-1.055-0.936-2.191-1.244-3.339-0.305-1.149-0.518-2.32-0.687-3.494-0.318-2.353-0.355-4.74-0.11-7.093 0.244-2.353 0.807-4.675 1.748-6.838 0.481-1.072 1.024-2.142 1.559-3.196 0.526-1.063 1.133-2.084 1.699-3.142-0.38 0.464-0.739 0.941-1.088 1.43-0.339 0.492-0.668 0.996-0.977 1.51-0.301 0.52-0.591 1.045-0.861 1.579-0.274 0.528-0.534 1.074-0.774 1.629-0.947 2.22-1.499 4.594-1.729 6.985-0.238 2.395-0.108 4.811 0.259 7.177 0.191 1.182 0.455 2.355 0.808 3.498 0.354 1.141 0.778 2.273 1.397 3.294",
    fill: "#dedbd7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.712 783.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c1.091 1.658 2.598 3.014 4.237 4.142 0.826 0.56 1.718 1.033 2.675 1.365 0.345 0.115 0.695 0.215 1.059 0.273 0.142 0.024 0.292 0.036 0.437 0.046 0.26 0.012 0.523 0.017 0.785-0.027 0.266-0.032 0.52-0.117 0.753-0.197 1.907-0.679 3.559-1.819 5.23-2.848 0.837-0.513 1.691-1.006 2.618-1.301 0.46-0.148 0.944-0.239 1.428-0.206 0.484 0.03 0.963 0.176 1.389 0.428-0.401-0.29-0.878-0.482-1.378-0.543-0.501-0.067-1.01-3e-3 -1.497 0.119-0.976 0.259-1.863 0.737-2.729 1.216-1.724 0.971-3.359 2.106-5.203 2.722-0.235 0.074-0.451 0.148-0.676 0.18-0.225 0.041-0.46 0.039-0.694 0.033-0.468-0.026-0.939-0.133-1.395-0.279-0.918-0.297-1.781-0.765-2.615-1.272-0.832-0.513-1.62-1.102-2.361-1.745-0.75-0.634-1.45-1.331-2.063-2.106",
    fill: "#ccc9c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.322 784.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.394 0.323 0.898 0.537 1.43 0.574 0.529 0.038 1.07-0.087 1.543-0.328 0.841-0.426 1.463-1.031 1.953-1.868 0.014-0.024 0.066-0.118 0.112-0.206 0.03-0.056 0.058-0.111 0.074-0.141 0.528-0.977 0.867-1.923 0.908-2.961 0.053-1.034-0.182-2.064-0.754-2.912 0.454 0.885 0.613 1.904 0.523 2.896-0.099 0.993-0.425 1.957-0.93 2.813-0.499 0.853-1.185 1.611-2.036 2.092-0.426 0.236-0.9 0.381-1.387 0.396-0.489 0.014-0.985-0.111-1.436-0.355",
    fill: "#bbb8b5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.417 747.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.471-2.191 1.199-4.317 2.224-6.294 0.501-0.995 1.07-1.953 1.696-2.873l0.958-1.377 0.478-0.696c0.158-0.232 0.3-0.478 0.451-0.714 0.607-0.949 1.125-1.95 1.619-2.964 0.466-1.026 0.865-2.083 1.176-3.168 0.297-1.086 0.518-2.194 0.617-3.315 0.108-1.12 0.125-1.592 0.084-2.709-0.027 1.119-0.077 1.587-0.233 2.692-0.147 1.107-0.377 2.2-0.702 3.264-0.331 1.064-0.76 2.094-1.22 3.106-0.496 0.996-1.015 1.983-1.625 2.917-0.151 0.234-0.295 0.473-0.451 0.703l-0.479 0.686c-0.315 0.456-0.645 0.916-0.955 1.384-0.623 0.939-1.19 1.917-1.685 2.928-0.984 2.029-1.65 4.209-1.953 6.43",
    fill: "#ccc9c6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.794 753.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.169-1.513 0.564-2.99 1.017-4.439 0.455-1.448 1.001-2.868 1.641-4.241 1.284-2.745 2.923-5.341 5.043-7.498 0.533-0.527 1.09-1.075 1.588-1.657 0.501-0.583 0.957-1.204 1.374-1.851 0.832-1.292 1.469-2.711 1.881-4.191 0.692-2.484 0.783-5.107 0.353-7.629-0.084-0.485-0.189-0.969-0.311-1.447 0.298 1.495 0.446 3.014 0.393 4.529-0.04 1.514-0.267 3.023-0.702 4.468-0.44 1.443-1.057 2.834-1.886 4.095-0.413 0.629-0.866 1.235-1.361 1.802-0.495 0.574-1.035 1.085-1.578 1.638-2.131 2.211-3.798 4.837-5.034 7.629-0.616 1.399-1.141 2.839-1.562 4.306-0.207 0.735-0.388 1.475-0.541 2.223-0.15 0.747-0.28 1.502-0.315 2.263",
    fill: "#d2cfcb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.943 757.84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.793 1.54 1.444 3.137 2.014 4.757 0.571 1.619 1.044 3.272 1.425 4.945 0.375 1.672 0.64 3.37 0.746 5.08 0.042 0.854 0.044 1.715-0.049 2.564l-0.066 0.64-0.133 0.629-0.064 0.316c-0.027 0.105-0.071 0.203-0.103 0.305l-0.206 0.615c0.81-1.546 1.005-3.348 1.001-5.079 0-0.873-0.062-1.744-0.174-2.61-0.105-0.864-0.253-1.723-0.443-2.574-0.367-1.702-0.881-3.37-1.522-4.987-0.646-1.612-1.438-3.176-2.426-4.601",
    fill: "#fffbf7"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cu)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.069 758.46c-0.061 0.293-0.099 0.457-0.099 0.457s0.033-0.162 0.099-0.457m-0.224-12.842c0.165-0.284 0.3-0.507 0.442-0.761 0.066-0.118 0.139-0.241 0.206-0.358 5.634-9.849 14.466-17.034 9.503-24.81-0.443-0.695-0.896-1.408-1.672-2.101 0.897 0.739 1.599 0.651 2.226 0.561 0.66-0.094 1.24-0.189 1.884 0.686 0.182 0.247 0.425 0.646 0.633 1.162 0.112 0.271 0.212 0.57 0.313 0.947 0 0 2.708-3.655 5.354-1 0.891 2.966 1.246 7.434-2.709 12.289-4.5 5.524-7.305 6.082-10.94 12.308-2.875 4.922-4.598 12.058-5.016 13.919 0.422-2.013 1.944-10.105-0.224-12.842",
    fill: "url(#ay)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cs)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.581 781.04c-0.809-3.564-1.317-8.785-0.506-14.116 0.353-2.331 2.079-7.42 2.47-9.873-0.993 7.831-4.718 22.816 7.216 28.499-2.842-0.705-8.428-4.894-9.18-4.51",
    fill: "url(#aw)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.136 790.4c-2.105-0.032-5.43-0.934-7.742-1.161-0.736-0.071-1.304-0.207-1.757-0.383-1.326-0.516-1.657-1.391-2.205-2.106-0.322-0.421-0.546-0.55-0.841-0.618-7e-3 -1e-3 -0.014-1e-3 -0.019-4e-3 -2.245-0.805-7.548-7.349-6.403-16.376 0.082-0.886 0.269-1.749 0.508-2.594 2.191-8.665 9.532-20.286 11.334-23.584-1.328-3.056-4.162-9.331-5.066-15.24-0.038-0.201-0.256-1.559-0.27-2.696-0.122-3.008 0.442-5.756 2.186-7.73 0.01-0.013 0.341-0.369 0.356-0.384 0.889-0.877 1.941-1.435 2.997-1.771h1e-3c1.496-0.642 2.636-0.283 3.733-0.096 0.493-0.298 1.007-0.528 1.53-0.707 3.148-1.088 6.669-0.215 8.32 0.707 2.213 0.719 3.222 2.02 3.854 4.032 0.637 1.896 1.612 5.768-0.594 11.496-0.994 2.475-2.986 6.347-6.06 11.974l-0.019 0.034c2.462 4.661 9.058 16.192 10.233 19.564 0.063 0.178 0.119 0.35 0.174 0.522 1.993 5.102 3.296 11.853-0.117 18.132-0.17 0.329-0.8 1.508-1.018 1.917-0.04 0.074-0.067 0.123-0.074 0.134-2.754 5.058-2.847 4.099-4.568 4.403-0.062 9e-3 -0.128 0.028-0.192 0.044-1.959 0.45-5.325 1.725-6.967 2.329-0.292 0.106-0.661 0.155-1.092 0.162zm2.15-44.426c-0.102 0.174-0.2 0.338-0.299 0.506-3.792 6.816-7.875 12.754-10.094 18.341-0.491 1.51-0.875 2.997-1.114 4.42-0.837 4.076-0.488 6.472 1.07 9.768 1.497 3.175 6.024 7.136 8.557 5.924 2.785-1.334 4.317-1.649 5.328-1.526 0.971 0.12 1.453 0.649 2.098 1.177 0.134 0.117 0.462 0.344 0.49 0.366 1.513-1.165 2.556-2.525 3.456-3.885 7.632-11.529-4.968-29.179-9.054-35.804-0.275 0.46-0.436 0.712-0.438 0.713m-9.382-26.539c-0.571 0.075-1.142 0.3-1.691 0.675-0.764 0.529-1.334 1.31-1.628 2.191-0.887 2.666-0.701 7.963 4.054 19.958 0.497-1.076 0.964-2.091 1.166-2.507 2.752-5.569 3.413-10.676 3.417-13.728-0.297-3.837-2.148-6.166-4.235-6.557-0.229-0.036-0.453-0.053-0.672-0.053-0.139 0-0.276 8e-3 -0.411 0.021",
    fill: "url(#au)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cn)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.242 790.41c-2.098-2e-3 -5.498-0.931-7.848-1.162-0.736-0.071-1.304-0.207-1.757-0.383-1.326-0.516-1.657-1.391-2.205-2.106-0.322-0.421-0.546-0.55-0.841-0.618-7e-3 -1e-3 -0.014-1e-3 -0.019-4e-3 -2.245-0.805-7.548-7.349-6.403-16.376 0.082-0.886 0.269-1.749 0.508-2.594 2.191-8.665 9.532-20.286 11.334-23.584-1.328-3.056-4.162-9.331-5.066-15.24-0.038-0.201-0.256-1.559-0.27-2.698-0.122-3.006 0.442-5.754 2.186-7.728 0.01-0.013 0.341-0.369 0.356-0.384 0.889-0.877 1.941-1.435 2.997-1.771h1e-3c1.496-0.642 2.636-0.283 3.733-0.096 0.493-0.298 1.007-0.528 1.53-0.707 1.069-0.369 2.18-0.512 3.247-0.506 2.075 0.015 3.984 0.605 5.073 1.213 2.213 0.719 3.222 2.02 3.854 4.032 0.637 1.896 1.612 5.768-0.594 11.496-0.994 2.475-2.986 6.347-6.06 11.974l-0.019 0.034c2.462 4.661 9.058 16.192 10.233 19.564 0.063 0.178 0.119 0.35 0.174 0.522 1.993 5.102 3.296 11.853-0.117 18.132-0.17 0.327-0.8 1.508-1.018 1.917-0.04 0.074-0.067 0.123-0.074 0.134-2.754 5.058-2.847 4.099-4.568 4.403-0.062 9e-3 -0.128 0.028-0.192 0.044-1.959 0.45-5.325 1.725-6.967 2.329-0.312 0.114-0.717 0.163-1.187 0.163zm2.044-44.427c-0.102 0.174-0.2 0.338-0.299 0.506-3.792 6.816-7.875 12.754-10.094 18.341-0.491 1.51-0.875 2.997-1.114 4.42-0.837 4.076-0.488 6.472 1.07 9.768 1.497 3.175 6.024 7.136 8.557 5.924 2.785-1.334 4.317-1.649 5.328-1.526 0.971 0.12 1.453 0.649 2.098 1.177 0.134 0.117 0.462 0.344 0.49 0.366 1.513-1.165 2.556-2.525 3.456-3.885 7.632-11.529-4.968-29.179-9.054-35.804-0.275 0.46-0.436 0.712-0.438 0.713m-9.382-26.539c-0.571 0.075-1.142 0.3-1.691 0.675-0.764 0.529-1.334 1.31-1.628 2.191-0.887 2.666-0.701 7.963 4.054 19.958 0.497-1.076 0.964-2.091 1.166-2.507 2.752-5.569 3.413-10.676 3.417-13.728-0.297-3.837-2.148-6.166-4.235-6.557-0.229-0.036-0.453-0.053-0.672-0.053-0.139 0-0.276 8e-3 -0.411 0.021",
    fill: "url(#ar)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.606 724.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.071 3.51-0.593 6.972-1.693 10.264-1.106 3.298-2.654 6.431-4.445 9.412-0.89 1.498-1.819 2.997-2.69 4.516-0.871 1.523-1.726 3.053-2.538 4.609-1.624 3.107-3.151 6.277-4.297 9.595 0.709-1.604 1.466-3.175 2.289-4.72 0.805-1.551 1.645-3.083 2.503-4.607 1.712-3.05 3.515-6.035 5.337-9.032 1.798-3.025 3.34-6.226 4.355-9.61 0.511-1.688 0.891-3.417 1.103-5.166 0.205-1.748 0.243-3.518 0.076-5.261",
    fill: "#e1deda"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)",
    opacity: 0.42999
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.231 758.6c0.805-1.55 1.647-3.084 2.503-4.607 0.353-0.628 0.709-1.254 1.07-1.878 1.034-1.647 2.191-3.343 3.46-4.988 5.821-7.554 9.479-15.249 6.842-22.675-0.479-1.352-0.238-1.986 0.369-2.012h0.08c1.674 0.068 5.759 4.284 5.825 10.631v0.31c-0.045 4.36-1.994 9.69-7.866 15.357-9.128 6.933-14.57 14.58-14.57 14.58 0.708-1.603 1.464-3.174 2.287-4.718",
    fill: "url(#aq)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.639 742.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.21 0.478-0.374 0.821-0.629 1.315-1.327-3.057-4.161-9.332-5.066-15.241-0.036-0.2-0.255-1.561-0.269-2.699 0.02-0.203 0.05-0.394 0.089-0.569 0.798-3.444 2.04-4.03 2.557-4.118-0.323 0.4-0.571 0.859-0.735 1.354-0.888 2.664-0.703 7.963 4.053 19.958",
    fill: "#f2efea"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.058 731.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.993 2.473-2.985 6.346-6.059 11.975l-0.019 0.031s-1.992 3.287-1.994 3.288c-3.791 6.816-7.873 12.753-10.094 18.343-0.489 1.508-0.875 2.995-1.113 4.418-2e-3 6e-3 -2e-3 0.011-3e-3 0.017-2e-3 0.01-3e-3 0.018-6e-3 0.026 0.216-1.384 0.16-2.817 0.606-5.022 0.864-4.124 2.737-8.681 6.179-12.908 4.059-4.981 8.665-11.065 10.782-20.405 0.272-1.201 0.679-3.879 0.84-6.363 0.194-2.995-0.366-5.086-1.435-7.291 0.026-0.037 0.669-0.893 2.532 1.708 0.15 0.227 0.269 0.457 0.378 0.686 0.637 1.896 1.613 5.767-0.594 11.497",
    fill: "#fffbf7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m54.769 776.4c0-1.546 1.253-2.797 2.799-2.797 1.547 0 2.8 1.251 2.8 2.797s-1.253 2.8-2.8 2.8c-1.546 0-2.799-1.254-2.799-2.8m3.173 1.324c-0.283 0.109-0.461 0.379-0.463 0.667 0.029 2e-3 0.058 8e-3 0.089 8e-3 0.459 0 0.877-0.159 1.214-0.421-0.135-0.189-0.355-0.301-0.584-0.301-0.086 0-0.172 0.015-0.256 0.047m-2.236-0.605c0.171 0.441 0.495 0.801 0.904 1.026 0.063-0.105 0.101-0.23 0.101-0.359 0-0.4-0.323-0.723-0.722-0.723-0.101 0-0.194 0.018-0.283 0.056m1.432-1.428-0.36 0.678c-0.04 0.077-0.026 0.171 0.032 0.234l0.536 0.552c0.06 0.063 0.154 0.081 0.231 0.042l0.691-0.338c0.079-0.038 0.123-0.121 0.11-0.208l-0.107-0.761c-0.012-0.087-0.079-0.155-0.163-0.17l-0.757-0.132c-0.011-2e-3 -0.024-2e-3 -0.035-2e-3 -0.074 0-0.142 0.039-0.178 0.105m1.784 0.568c0 0.342 0.239 0.625 0.555 0.703 0.054-0.18 0.09-0.365 0.09-0.562 0-0.29-0.064-0.565-0.178-0.814-0.272 0.102-0.467 0.365-0.467 0.673m-3.291-0.331c0.058 0.015 0.119 0.025 0.183 0.025 0.397 0 0.722-0.322 0.722-0.722 0-0.166-0.056-0.314-0.15-0.436-0.372 0.275-0.643 0.671-0.755 1.133m1.758-1.509c0.045 0.355 0.345 0.629 0.712 0.629 0.241 0 0.454-0.121 0.586-0.304-0.318-0.216-0.703-0.342-1.119-0.342-0.062 0-0.121 0.011-0.179 0.017",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.9 781.48 0.646-1.12 1.12 0.646-0.646 1.12z",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.31 771.44 0.932-0.899 0.899 0.928-0.931 0.902z",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.093 724.42c-0.1-0.131-0.154-0.35-0.178-0.631-0.024-0.285-0.014-0.54 7e-3 -0.783-0.105 0.115-0.313 0.153-0.424 0.068 0.029-0.113 0.067-0.216 0.082-0.337 0.012-0.084 0.012-0.177 0.013-0.267-0.195-0.143-0.42-0.337-0.451-0.699-5e-3 -0.058-3e-3 -0.111-3e-3 -0.166-0.073 0.23-0.2 0.465-0.263 0.665-0.057 0.178-0.159 0.349-0.259 0.439-0.029 0.029-0.067 0.038-0.102 0.059-0.022-0.059-0.039-0.122-0.061-0.176-9e-3 -0.027-0.013-0.055-0.024-0.109-0.067 0.069-0.121 0.132-0.188 0.181-0.05 0.036-0.11 0.052-0.171 0.064-0.128 0.029-0.15-2e-3 -0.15-0.189 0-0.061-3e-3 -0.126-5e-3 -0.206-0.279 0.107-0.434-0.119-0.428-0.125 0.059-0.055 0.111-0.089 0.124-0.174 0.013-0.08-0.019-0.206-0.059-0.315-0.08-0.216-0.027-0.583 0.128-0.726 0.111-0.103 0.317-0.084 0.462 0.057 0.168 0.156 0.22 0.638 0.126 0.788-0.057 0.09-0.097 0.091-0.208 0.015 0.029-0.063 0.087-0.124 0.079-0.195-8e-3 -0.08-0.064-0.191-0.121-0.254-0.078-0.084-0.166-0.092-0.229-0.023-0.11 0.123-0.112 0.336-0.01 0.536 0.029 0.055 0.101 0.158 0.138 0.186 0.158 0.115 0.345 0.148 0.46 0.066 0.128-0.091 0.206-0.238 0.222-0.456 0.03-0.38-0.167-0.972-0.149-1.35 0.013-0.35 0.263-0.488 0.554-0.545 0.128-0.025 0.459-0.063 0.527-0.088 0.346-0.124 0.646-0.105 0.83 0.214 0.189 0.327 0.292 0.944 0.494 1.269 0.117 0.185 0.252 0.279 0.408 0.305 0.142 0.019 0.292-0.091 0.38-0.267 0.022-0.042 0.036-0.165 0.038-0.229-4e-3 -0.224-0.105-0.413-0.258-0.47-0.091-0.033-0.166 0.011-0.195 0.123-0.021 0.081-0.019 0.205 0.012 0.282 0.025 0.065 0.103 0.091 0.158 0.135-0.063 0.119-0.099 0.138-0.191 0.083-0.153-0.092-0.313-0.535-0.235-0.749 0.061-0.191 0.237-0.301 0.382-0.26 0.207 0.058 0.404 0.348 0.436 0.581 0.014 0.112 0.046 0.238 0.092 0.305 0.051 0.071 0.112 0.077 0.193 0.097 6e-3 2e-3 0.011 0.016 0.022 0.033-0.045 0.245-0.213 0.205-0.345 0.271 0.034 0.075 0.061 0.131 0.091 0.188 0.087 0.166 0.081 0.204-0.047 0.233-0.059 0.016-0.119 0.032-0.182 0.021-0.08-0.011-0.159-0.046-0.25-0.076 0.014 0.053 0.023 0.08 0.028 0.106 8e-3 0.06 0.021 0.125 0.029 0.186-0.016-2e-3 -0.03-2e-3 -0.044 0-0.026 0-0.051 2e-3 -0.078-6e-3 -0.128-0.036-0.214-0.116-0.377-0.212-0.152-0.09-0.348-0.317-0.507-0.545 0.019 0.079 0.041 0.156 0.07 0.227 0.103 0.263 0.084 0.425-0.018 0.551l-0.116 0.188c0.012 0.028 0.025 0.06 0.037 0.097 0.054 0.176 0.137 0.313 0.202 0.487-0.029 0.111-0.227 0.214-0.358 0.168 0.074 0.238 0.125 0.497 0.127 0.799-2e-3 0.276-0.067 0.446-0.141 0.577-0.011 0.019-0.027 0.027-0.043 0.027-0.028 0-0.059-0.021-0.083-0.049m-5.084-3.269c-0.045 0.157-0.091 0.316-0.14 0.487-0.208-0.041-0.332-0.2-0.422-0.37-0.088-0.169-0.134-0.357-0.202-0.53-0.084 0.072-0.168 0.148-0.254 0.224-0.268-0.317-0.312-0.649-0.069-1.037 0.199-0.316 0.434-0.606 0.659-0.893 0.256-0.329 0.516-0.643 0.534-1.073 0.019-0.402-0.197-0.753-0.539-1.04-0.271-0.229-0.572-0.314-0.95-0.316-0.012 0-0.044-0.112-0.05-0.133 0.034-0.157 0.316-0.086 0.458-0.05 1.067 0.27 1.756 1.08 1.436 1.9-0.123 0.326-0.539 0.844-0.698 1.16-0.133 0.259-0.252 0.521-0.195 0.827 0.071 0.361 0.423 0.713 0.87 0.639 0.254-0.041 0.455-0.251 0.453-0.506-2e-3 -0.164-0.142-0.381-0.304-0.452-0.105-0.044-0.214-0.059-0.295 0.017-0.074 0.074-0.074 0.166-0.025 0.266 8e-3 0.016 0.01 0.034 0.014 0.053-0.164-0.013-0.37-0.237-0.347-0.412 0.043-0.306 0.731-0.55 1.047-0.342 0.29 0.188 0.446 0.628 0.342 0.982-0.101 0.342-0.255 0.521-0.58 0.626-0.035 0.014-0.065 0.028-0.091 0.042 0.065 0.164 0.118 0.306 0.173 0.462-0.02 1e-3 -0.041 1e-3 -0.062 1e-3 -0.358 0-0.559-0.225-0.763-0.532m2.446-1.259c-0.208-0.089-0.458-0.338-0.505-0.51 0.102 0.027 0.197 0.061 0.285 0.076 0.191 0.024 0.32-0.07 0.354-0.248 0.028-0.151-0.082-0.416-0.235-0.545-0.248-0.211-0.51-0.397-0.767-0.592-0.299-0.221-0.433-0.483-0.411-0.781 0.027-0.398 0.362-0.682 0.421-0.739-0.519-0.659-1.135-1.209-1.761-1.709 0.172-0.05 0.345-0.098 0.517-0.136 0.564 0.48 1.114 0.99 1.646 1.573 0.452-0.199 1.005-0.243 1.439 0.091 0.279 0.216 0.408 0.478 0.52 0.753 0.085 0.208 0.15 0.419 0.222 0.631 0.1 0.288 0.309 0.52 0.528 0.606 0.201 0.078 0.321-0.021 0.339-0.283 1e-3 -0.035 3e-3 -0.067 7e-3 -0.125 0.138 0.175 0.189 0.352 0.227 0.517 0.067 0.315-7e-3 0.508-0.139 0.634-0.157 0.147-0.421 0.158-0.69-0.046-0.105-0.075-0.239-0.227-0.336-0.375-0.128-0.196-0.232-0.394-0.33-0.594-0.318-0.421-0.576-0.695-0.752-0.859 0.195 0.292 0.344 0.602 0.474 0.915 0.113 0.27 0.206 0.544 0.296 0.82 0.012 0.034 0.017 0.07 0.031 0.133-0.048-0.046-0.075-0.063-0.096-0.09-0.374-0.453-0.796-0.864-1.215-1.266-0.042-0.039-0.074-0.083-0.113-0.126 0.018 0.216 0.176 0.496 0.341 0.739 0.062 0.063 0.12 0.126 0.175 0.194 0.172 0.203 0.321 0.448 0.415 0.685 0.12 0.311 0.017 0.51-0.163 0.631-0.105 0.072-0.222 0.112-0.355 0.112-0.109 0-0.233-0.028-0.369-0.086m-4.272-0.768c-0.182 0.011-0.547 0.025-0.551 0.011 1.022-0.517 1.323-1.228 1.489-2.098 0.22 0.107 0.437 0.763 0.399 1.108-0.051 0.479-0.317 0.828-0.754 1.16-0.012-0.066-0.02-0.104-0.032-0.154-0.238 0.109-0.387 0.34-0.69 0.389 0.049-0.15 0.093-0.28 0.139-0.416m9.21-1.253c-0.017 9e-3 -0.043 0.019-0.071 0.034-0.197 0.111-0.936 0.277-1.315-0.13-0.261-0.289-0.573-1.015-0.095-1.328 0.117-0.074 0.202-0.146 0.388-0.055 0.155 0.079 0.258 0.223 0.33 0.388 0.014 0.03 0.016 0.063 0.027 0.11-0.03-0.023-0.046-0.032-0.061-0.049-0.154-0.168-0.244-0.212-0.319-0.161-0.075 0.046-0.134 0.323-0.049 0.476 0.227 0.407 0.655 0.544 0.867 0.414 0.168-0.104 0.206-0.328 0.071-0.661-0.158-0.389-0.423-0.701-0.742-0.833-0.291-0.12-0.577-0.166-0.863-0.204-0.178-0.021-0.354 0.021-0.539 0.061-0.233 0.053-0.476 0.105-0.738 0.032-0.707-0.202-1.532-0.852-2.001-1.504 0.094-5e-3 0.187-7e-3 0.281-7e-3 0.136 0.16 0.298 0.317 0.488 0.461 0.544 0.42 1.083 0.636 1.591 0.613 0.401-0.021 0.757-0.097 1.129-0.113 0.228-0.011 0.451-0.025 0.688 0.017 0.333 0.06 0.656 0.314 0.937 0.776-0.09 0.019-0.173 0.036-0.266 0.059 0.39 0.35 0.701 0.759 0.803 1.301-0.161-0.112-0.31-0.205-0.466-0.296 0.103 0.217 0.204 0.423 0.267 0.624 0.067 0.213 0.059 0.385-0.017 0.502-0.107-0.178-0.206-0.342-0.325-0.527m-7.757-1.514c-0.223-0.182-0.217-0.485-0.033-0.724 0.062-0.081 0.133-0.151 0.181-0.207 0.193 0.159 0.359 0.322 0.546 0.465 0.414 0.319 0.534 0.689 0.474 1.072-0.014 0.094-0.041 0.185-0.066 0.304-0.374-0.334-0.752-0.621-1.102-0.91m-1.832-0.119c-0.199 8e-3 -0.388 0.018-0.579 0.041-2e-3 -0.016 0.212-0.222 0.338-0.317-0.091-0.077-0.176-0.147-0.262-0.216 0.912 0.036 1.59-0.386 2.269-0.809-0.087 0.547-0.862 1.284-1.802 1.418 0.011-0.038 0.022-0.074 0.036-0.117m3.64-1.17c-0.145-0.167-0.347-0.323-0.519-0.474 0.324-0.056 0.643-0.092 0.962-0.112 0.037 0.017 0.074 0.037 0.108 0.063 0.177 0.127 0.322 0.298 0.469 0.459 0.107 0.119 0.188 0.255 0.291 0.382 0.096 0.121 0.205 0.237 0.311 0.363-0.657-0.019-1.207-0.202-1.622-0.681m3.409 0.024c-0.564-0.048-1.185-0.306-1.782-0.629 0.942 0.035 1.842 0.186 2.637 0.396-0.18 0.157-0.407 0.239-0.704 0.239-0.048 0-0.099-3e-3 -0.151-6e-3",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ci)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.298 744.07c-0.03-4e-3 -0.055-0.02-0.057-0.05v-0.01c0.01-0.165 0.055-0.356 0.217-0.603 0.179-0.273 0.375-0.476 0.583-0.647-0.143-0.038-0.26-0.246-0.217-0.364 0.159-0.117 0.315-0.193 0.466-0.319 0.317-0.26 0.48-0.121 0.505-4e-3 7e-3 0.042-0.042 0.118-0.115 0.206 0.067-0.061 0.143-0.102 0.222-0.101 0.139 0.031 0.233 0.095 0.128 0.313-0.056 0.111-0.157 0.238-0.212 0.354-0.058 0.122-0.085 0.235-0.127 0.353-0.149 0.012-0.313-0.143-0.336-0.309-0.126 0.232-0.268 0.468-0.459 0.709-0.186 0.239-0.366 0.405-0.531 0.464-0.012 4e-3 -0.025 7e-3 -0.037 8e-3zm2.668-1.031c0.038-0.268 0.318-0.714 0.598-1.059-0.121 0.285-0.072 0.447 0.038 0.588 0.042 0.052 0.031 0.249-0.122 0.436-0.059 0.073-0.195 0.21-0.284 0.235-0.029 9e-3 -0.057 0.013-0.08 0.013-0.121 0-0.165-0.106-0.15-0.213m1.888-0.252c-0.065-0.052-0.181-0.147-0.246-0.506-0.054 0.071-0.205 0.205-0.277 0.268-0.027-0.046-0.064-0.08-0.079-0.134-0.05-0.164-0.023-0.361 0.092-0.575 0.196-0.371 0.411-0.736 0.628-1.099 0.4-0.67 0.784-1.313 0.566-1.901 0.046 3e-3 0.061 2e-3 0.069 3e-3 0.015 5e-3 0.023 0.024 0.035 0.031 0.299 0.209 0.521 0.562 0.303 0.986-0.224 0.438-0.825 0.988-1.034 1.437-0.122 0.257-0.128 0.473-0.043 0.658 0.078 0.166 0.306 0.25 0.558 0.222 0.06-8e-3 0.207-0.081 0.274-0.123 0.245-0.166 0.381-0.409 0.333-0.615-0.027-0.119-0.13-0.17-0.271-0.121-0.104 0.036-0.239 0.126-0.3 0.211-0.054 0.074-0.027 0.178-0.035 0.269-0.174 0.017-0.22-9e-3 -0.225-0.147-0.011-0.231 0.269-0.564 0.558-0.633 0.252-0.069 0.5 0.043 0.558 0.229 0.084 0.263-6e-3 0.53-0.236 0.728-0.114 0.094-0.23 0.218-0.268 0.318-0.039 0.101-3e-3 0.174 0.028 0.277 4e-3 9e-3 -8e-3 0.023-0.017 0.046-0.3 0.126-0.377-0.083-0.543-0.179-0.054 0.091-0.097 0.161-0.14 0.234-0.071 0.126-0.113 0.181-0.166 0.181-0.033 0-0.071-0.023-0.122-0.065m-2.344-0.377c-0.05-0.047-0.082-0.145-0.03-0.239 0.101-0.191 0.306-0.381 0.532-0.49 0.431-0.208 0.822-0.521 1.112-0.921 0.05-0.071 0.098-0.143 0.145-0.216-0.249 0.247-0.539 0.473-0.802 0.703-0.283 0.243-0.556 0.356-0.787 0.345-0.068-4e-3 -0.116-0.066-0.113-0.134 0.011-0.238 0.172-0.482 0.413-0.774 0.204-0.247 0.408-0.531 0.63-0.799-0.047 0.04-0.096 0.077-0.143 0.117-0.341 0.275-0.637 0.607-0.875 0.99-0.119 0.192-0.643 0.835-0.87 0.513-0.082-0.116 0.044-0.348 0.287-0.535 0.216-0.164 0.437-0.302 0.655-0.46 4e-3 -0.264 0.105-0.434 0.42-0.663 0.182-0.129 0.364-0.228 0.545-0.354 0.054-0.038 0.132-0.109 0.151-0.16 0.092-0.258 0.262-0.394 0.447-0.476 0.211-0.093 0.401-0.097 0.537-0.093 0.124 5e-3 0.252 0.072 0.338 0.188 0.127 0.169 0.205 0.613 0.015 0.966-0.063 0.116-0.181 0.25-0.29 0.342-0.088 0.078-0.141 0.128-0.192 0.237-0.102 0.223-0.232 0.445-0.383 0.659-0.216 0.3-0.405 0.397-0.613 0.374-0.182 0.226-0.347 0.436-0.539 0.629-0.174 0.173-0.379 0.279-0.504 0.279-0.036 0-0.066-9e-3 -0.086-0.028m-1.47-1.907c1e-3 -0.304 0.455-0.347 0.567-0.304 0.138 0.053 0.226 0.159 0.362 0.208 0.093 0.03 0.235-6e-3 0.404-0.016-0.296 0.186-0.744 0.406-1.037 0.406-0.176 0-0.297-0.079-0.296-0.294m0.649-0.551c-0.053-0.012-0.09-0.046-0.137-0.069 0.065-0.077 0.164-0.229 0.249-0.294-0.123-0.027-0.232-0.037-0.329-0.075-0.078-0.028-0.134-0.083-0.193-0.138-0.123-0.117-0.104-0.164 0.097-0.296 0.071-0.046 0.136-0.093 0.226-0.154-0.315-0.224-0.178-0.553-0.168-0.551 0.102 0.027 0.176 0.058 0.277 0.012 0.096-0.046 0.213-0.17 0.3-0.288 0.184-0.244 0.444-0.35 0.712-0.284 0.191 0.046 0.315 0.285 0.263 0.543-0.052 0.291-0.364 0.594-0.594 0.597-0.139 3e-3 -0.169-0.041-0.164-0.214 0.092-0.016 0.195 6e-3 0.266-0.052 0.082-0.067 0.164-0.207 0.193-0.314 0.039-0.145-0.017-0.242-0.138-0.261-0.209-0.035-0.444 0.116-0.592 0.37-0.04 0.071-0.101 0.22-0.105 0.282-0.013 0.254 0.084 0.476 0.256 0.542 0.191 0.073 0.405 0.052 0.653-0.084 0.435-0.241 0.945-0.874 1.369-1.125 0.409-0.244 0.776-0.047 1.003 0.238 8e-3 0.011 0.027 0.019 0.033 0.033 1e-3 7e-3 0 0.024 7e-3 0.07-0.6-0.181-1.217 0.244-1.861 0.685-0.346 0.24-0.698 0.479-1.054 0.699-0.155 0.095-0.303 0.144-0.438 0.144-0.045 0-0.089-6e-3 -0.131-0.016m5.036-0.311c-0.321-0.166-0.463-0.616-0.167-1.193 0.073-0.138 0.161-0.284 0.262-0.411 0.392-0.496 0.832-0.898 1.267-1.309 0.264-0.254 0.512-0.529 0.763-0.807 0.646-0.719 0.527-1.572 0.545-1.612 0.288 0.469 0.54 0.952 0.303 1.7-0.151 0.467-0.468 0.785-0.795 1.069-0.248 0.218-0.508 0.403-0.766 0.604-0.351 0.273-0.575 0.672-0.589 1.013-0.013 0.311 0.18 0.429 0.551 0.326 0.048-0.013 0.076-0.02 0.16-0.044-0.136 0.252-0.38 0.423-0.593 0.553-0.229 0.139-0.425 0.194-0.596 0.194-0.129 0-0.243-0.032-0.345-0.083m-0.533-1.965c0.449-0.728 0.818-1.502 1.176-2.269 0.181-0.38 0.44-0.73 0.677-1.064 0.088-0.122 0.272-0.156 0.411-0.183 0.097-0.019 0.165-0.047 0.227-0.164 0.801-1.468 1.43-3.002 1.934-4.481 0.015-0.05 0.027-0.126 8e-3 -0.169-0.221-0.443-0.087-0.76 0.143-1.048 0.182-0.23 0.517-0.696 0.648-0.685 0.027 0.277 0.058 0.55 0.053 0.822-1e-3 0.245-0.011 0.503-0.082 0.732-0.042 0.139-0.195 0.22-0.298 0.33-0.074 0.078-0.182 0.138-0.216 0.235-0.533 1.445-1.171 2.951-1.976 4.381-0.08 0.148-0.099 0.25-0.049 0.394 0.084 0.251 5e-3 0.53-0.143 0.792-0.381 0.665-0.894 1.179-1.428 1.651-0.321 0.283-0.655 0.539-0.994 0.795-0.042 0.033-0.088 0.055-0.168 0.105 0.039-0.086 0.052-0.134 0.077-0.174m-1.451-0.357c-0.277-0.205-0.412-0.511-0.378-0.979 0.026-0.326 0.25-0.788 0.466-0.934 0.012 0.151 9e-3 0.298 0.031 0.424 0.057 0.272 0.248 0.407 0.508 0.369 0.224-0.036 0.537-0.313 0.642-0.584 0.176-0.438 0.313-0.886 0.457-1.331 0.166-0.514 0.463-0.831 0.887-0.936 0.345-0.086 0.679-0.02 1.016 0.131-0.143 0.087-0.254 0.158-0.37 0.224-0.366 0.213-0.608 0.585-0.794 1.025-0.232 0.548-0.449 1.109-0.762 1.617-0.201 0.334-0.468 0.654-0.753 0.895-0.192 0.161-0.371 0.227-0.535 0.227-0.153 0-0.293-0.058-0.415-0.148m-2.817-3.523c-0.227 0.038-0.458 0.074-0.708 0.114-0.069-0.285 0.059-0.539 0.223-0.757 0.163-0.212 0.376-0.38 0.558-0.569-0.144-0.065-0.292-0.126-0.437-0.188 0.244-0.527 0.644-0.785 1.284-0.711 0.522 0.062 1.031 0.188 1.536 0.302 0.575 0.127 1.13 0.268 1.691 0.033 0.528-0.218 0.846-0.7 1.01-1.304 0.129-0.481 0.058-0.914-0.164-1.392-7e-3 -0.014 0.1-0.117 0.142-0.143 0.065 0.194 0.265 0.494 0.306 0.695 0.294 1.51-0.719 2.566-1.961 2.652-0.489 0.04-0.985-0.019-1.485-0.032-0.41-0.013-0.818-6e-3 -1.171 0.248-0.42 0.308-0.661 0.963-0.3 1.484 0.207 0.297 0.595 0.423 0.917 0.271 0.212-0.101 0.406-0.408 0.398-0.656-4e-3 -0.162-0.05-0.308-0.197-0.364-0.14-0.051-0.256 3e-3 -0.356 0.128-0.016 0.018-0.038 0.031-0.057 0.047-0.084-0.214 0.081-0.606 0.32-0.682 0.414-0.131 0.831 0.402 0.754 0.925-0.067 0.479-0.29 0.881-0.711 1.069-0.462 0.205-0.854 0.132-1.182-0.212-0.039-0.038-0.075-0.066-0.108-0.094-0.173 0.181-0.323 0.334-0.488 0.498-0.272-0.486-0.101-0.897 0.186-1.362m2.347-0.788c0.471 0.015 0.961 0.619 0.739 1.156-0.16 0.401-0.643 0.731-1.018 0.961 0.581-0.665 0.816-1.387 0.279-2.117m6.016-0.837c0.166-0.279 0.276-0.602 0.401-0.906 0.452 0.275 0.772 0.821 0.586 1.412-0.095 0.302-0.259 0.581-0.412 0.856-0.117 0.206-0.264 0.384-0.39 0.583-0.124 0.191-0.232 0.394-0.357 0.599-0.287-0.909-0.294-1.747 0.172-2.544m-1.741-1.138c0.147-0.393 0.569-0.531 0.988-0.393 0.14 0.048 0.273 0.111 0.372 0.15-0.129 0.341-0.276 0.643-0.385 0.968-0.243 0.72-0.698 1.061-1.258 1.162-0.137 0.023-0.279 0.031-0.453 0.053 0.287-0.671 0.502-1.322 0.736-1.94m-4.974 0.062c0.086-0.05 0.134-0.076 0.198-0.116-0.261-0.276-0.653-0.368-0.867-0.759 0.233-4e-3 0.435-6e-3 0.642-8e-3 -0.099-0.243-0.291-0.738-0.275-0.751 1.2 1.156 2.326 1.23 3.608 1.039-0.043 0.353-0.849 0.965-1.344 1.077-0.158 0.036-0.312 0.054-0.463 0.054-0.508 0-0.986-0.197-1.499-0.536m7.592-0.371c0.321 0.126 0.64 0.243 0.955 0.309-0.021 0.054-0.04 0.109-0.061 0.162-0.054 0.135-0.113 0.276-0.172 0.42-0.314-0.254-0.579-0.579-0.722-0.891m0.063-0.795c-0.018-6e-3 -0.031-0.032-0.063-0.08 0.482-0.086 0.661-0.51 0.751-1.001 0.279 0.068 0.405 0.308 0.527 0.525 0.105-0.096 0.203-0.21 0.315-0.292-0.097 0.353-0.206 0.715-0.329 1.085-0.064 7e-3 -0.129 0.012-0.192 0.012-0.34 0-0.675-0.104-1.009-0.249m-4.191-1.691c0.058-2e-3 0.116-3e-3 0.181-4e-3 -0.106-0.267-0.211-0.524-0.332-0.773 0.019-0.012 0.409 0.183 0.6 0.311 0.063-0.164 0.118-0.312 0.173-0.462 0.385 1.267 1.288 1.991 2.195 2.72-0.067 0.012-0.138 0.017-0.212 0.017-0.814 0-2.025-0.69-2.605-1.809m2.947 0.858c-0.314-0.27-0.606-0.568-0.764-0.976-0.155-0.392-0.106-0.706 0.145-0.973 0.315 0.287 0.55 0.576 0.458 0.94 0.22 0.012 0.43 0.027 0.696 0.046-0.197 0.433-0.319 0.816-0.05 1.278-0.015 0.012-0.028 0.025-0.044 0.035-0.141-0.119-0.296-0.228-0.441-0.35m1.857-0.558c0.162-0.276 0.277-0.519 0.44-0.72 0.113-0.149 0.299-0.247 0.529-0.149 0.08 0.032 0.188 0.116 0.243 0.199-0.022 0.107-0.046 0.214-0.071 0.324-0.162-0.019-0.287 0.076-0.39 0.151-0.172 0.123-0.356 0.202-0.611 0.202-0.044 0-0.091-2e-3 -0.14-7e-3m-1.662-1.307c-0.065-0.214-0.155-0.39-0.441-0.451 0.114-0.166 0.288-0.197 0.489-0.174 0.189 0.023 0.321 0.157 0.403 0.304 0.125 0.223 0.139 0.491 0.109 0.722-0.016 0.127-0.041 0.277-0.082 0.36-0.26-0.238-0.392-0.493-0.478-0.761m1.97-0.364c0.223-0.127 0.549 0.02 0.728 0.387-0.297-0.082-0.404 0.105-0.556 0.259-0.134 0.134-0.306 0.222-0.478 0.343-0.089-0.373 0.064-0.855 0.306-0.989m-1.248 0.06c7e-3 -0.202 0.01-0.384-0.197-0.571 0.197-0.058 0.369-9e-3 0.539 0.126 0.153 0.118 0.199 0.264 0.191 0.429-0.015 0.287-0.225 0.63-0.495 0.757-6e-3 -0.271-0.049-0.517-0.038-0.741m0.916-0.845c0.026-0.04 0.059-0.062 0.1-0.066h0.03c0.035 3e-3 0.076 0.016 0.124 0.04 0.137 0.069 0.183 0.147 0.162 0.253-0.056 0.299-0.275 0.485-0.516 0.664-0.046-0.34-0.059-0.646 0.1-0.891",
    fill: "url(#al)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.62 746.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 0.408 0.233-1.111 1.937-0.408-0.233 0.427-0.747-2.018-1.159 0.254-0.444 2.019 1.16zm1.821-2.227-1.998-0.317 1.274 1.578-0.396 0.687-2.425-1.393 0.253-0.443 1.856 1.065 7e-3 -0.012-1.464-1.747 0.208-0.362 2.246 0.381 7e-3 -9e-3 -1.854-1.066 0.254-0.443 2.426 1.392z",
    fill: "#bcbab7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCup);
export default __webpack_public_path__ + "static/media/logo-cup.5b5edc8e6db25c660af3a83372bbe249.svg";
export { ForwardRef as ReactComponent };